import React, { useState } from 'react';
import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar, Toolbar, IconButton, MenuItem, Menu, Container, Box } from '@mui/material';
import { useStyles } from './styles';

function Header({ menuItems, logo }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const openMobileMenu = Boolean(anchorEl);

  return (
    <Box sx={classes.grow}>
      <AppBar position="static" color="inherit" elevation={0}>
        <Container disableGutters>
          <Toolbar>
            <Box component="a" href="/" sx={classes.logo}>
              <Box component="img" src={logo} alt="Jitsu" sx={classes.logoImg} height={52} />
            </Box>
            <Box sx={classes.grow} />
            <Box sx={classes.sectionDesktop}>
              {menuItems && (
                <Box component="ul" sx={classes.mainMenu}>
                  {menuItems.map((menuItem, i) => (
                    <Box component="li" key={`menu-${i}`} sx={classes.mainMenuItem}>
                      <Box
                        component="a"
                        sx={{
                          ...classes.mainMenuItemLink,
                          ...(menuItem.isActive && { color: (theme) => theme.colorTokens.hyperlink }),
                        }}
                        href={menuItem.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {menuItem.title}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <Box sx={classes.sectionMobile}>
              <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={(e) => setAnchorEl(e.currentTarget)} size="large">
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        id="primary-search-account-menu-mobile"
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={openMobileMenu}
        onClose={() => setAnchorEl(null)}
      >
        {menuItems.map((menuItem, i) => (
          <MenuItem key={`mobile-menu-${i}`}>
            <Box
              component="a"
              sx={{
                ...classes.mainMenuItemLink,
                ...(menuItem.isActive && { color: (theme) => theme.colorTokens.hyperlink }),
              }}
              href={menuItem.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {menuItem.title}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default Header;
